export default "__VITE_ASSET__sWtUQ0KK__"